/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'
import { authenticate } from 'services'
import { authenticationError, authenticationErrorResponse } from 'constant/response'

import AppLayout from 'components/layouts/app'
import Button from 'components/commons/button'

const LoginPage = () => {
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState({
    email: '',
    password: '',
  })
  const [error, setError] = useState<string | null>(null)

  const navigate = useNavigate()

  /**
   * this method will unmount local states
   */
  useEffect(() => {
    return () => {
      setLoading(false)
      setState({
        email: '',
        password: '',
      })
      setError(null)
    }
  }, [])

  const changeText = (props: string) => (e: any) => {
    const form: any = { ...state }
    form[props] = e.target.value
    setState(form)
  }

  const onLogin = async (e: any) => {
    e.preventDefault()

    if (state.email && state.password) {
      try {
        setLoading(true)
        const response: any = await authenticate(state.email, state.password)
        const token = await response.user.getIdToken()

        setLoading(true)

        setTimeout(() => {
          if (localStorage.getItem('adminAccess') == 'true') {
            localStorage.setItem('token', token)
            navigate('/invalid-solana-nfts')
          } else {
            setError('Error - Your Account Does Not Have Admin Access')
          }
        }, 1500)
      } catch (e: any) {
        if (authenticationError.includes(e.code)) {
          setError(authenticationErrorResponse.invalid)
        } else {
          setError(authenticationErrorResponse.serverError)
        }
        setLoading(false)
      }
    }
  }

  return (
    <React.Fragment>
      <AppLayout>
        <div className='m-auto px-4 md:px-0 lg:px-0'>
          <div className='bg-white p-10 rounded-lg'>
            <h1 className='text-2xl font-bold text-center'>NFTfolio</h1>
            <div className='w-full bg-gray-200 my-6 h-0.5'></div>

            {error && <p className='italic text-red-500 my-2'>{error}</p>}

            <form onSubmit={onLogin}>
              <div className='mb-4'>
                <label>Email address</label>
                <input
                  type='email'
                  placeholder='Enter email address'
                  className='border rounded-md p-2 w-full'
                  onChange={changeText('email')}
                  required={true}
                />
              </div>
              <div className='mb-4'>
                <label>Password</label>
                <input
                  type='password'
                  placeholder='Enter password'
                  className='border rounded-md p-2 w-full'
                  onChange={changeText('password')}
                  required={true}
                />
              </div>
              <Button
                className='bg-blue-500 hover:bg-blue-dark text-white font-bold py-2 px-4 mt-6 rounded'
                type='submit'
                disabled={loading}
              >
                Sign In
              </Button>
            </form>
          </div>
        </div>
      </AppLayout>
    </React.Fragment>
  )
}

export default LoginPage
